export enum FeatureKey {
  User = 'user',
  Farm = 'farm',
  Pond = 'pond',
  Cycle = 'cycle',
  // NK-246: the daily-record table used to be stored as 'dashboard'; the
  // 'dashboard' key is now the pond overview tab, granted separately.
  DailyRecord = 'daily_record',
  Dashboard = 'dashboard',
  Food = 'food',
  Growth = 'growth',
  Death = 'dead_shrimp',
  WaterQuality = 'water_quality',
  WaterMineral = 'water_mineral',
  WaterVibrio = 'water_vibrio',
  Medicine = 'medicine',
  Cost = 'cost',
  Sales = 'sales',
  PdfSummary = 'pdf_summary',
  PdfDaily = 'pdf_daily',
  PdfFeatures = 'pdf_features',
  ImportReactant = 'import_reactant',
  Lab = 'lab',
  // NK-276: the ไซส์กุ้ง tab used to ride on Lab. Its own key so a role can be
  // granted one of the two side-by-side tabs without the other.
  ShrimpSizeOverview = 'shrimp_size_overview',
  Partial = 'partial',
  ShrimpSales = 'shrimp_sales',
  OrganizationOverview = 'organization_overview',
  // NK-271: gates the ภาพรวมฟาร์ม summary row (FCR/อัตรารอด/ADG เฉลี่ย) on the
  // บ่อทั้งหมด page. The figures ride on the pond list itself, so this hides the
  // row only — the ponds stay visible without it.
  FarmOverview = 'farm_overview',
}

export enum CRUDAction {
  Create = 0,
  Read = 1,
  Update = 2,
  Delete = 3,
}

export const FREE_MODULES = [FeatureKey.Farm, FeatureKey.Pond, FeatureKey.Cycle, FeatureKey.User]
export const TAB_MODULES = [
  FeatureKey.DailyRecord,
  FeatureKey.Dashboard,
  FeatureKey.Food,
  FeatureKey.Growth,
  FeatureKey.Partial,
  FeatureKey.Death,
  FeatureKey.WaterQuality,
  FeatureKey.WaterMineral,
  FeatureKey.WaterVibrio,
  FeatureKey.Medicine,
  FeatureKey.Cost,
  FeatureKey.Sales,
  FeatureKey.Cycle,
]
